export enum InvoiceRowType {
    UNSPECIFIED = 'unspecified',
    CAR_WASH_MONTHLY_PAYMENT = '17100',
    DAILY_RENT = '14052',
    ELECTRICAL_CHARGING = '15001',
    EXPORT_PERMIT_FINANCING_COMPANY = '14999',
    FINANCING_FIRST_PAYMENT = '14057',
    FINANCING_INITIAL_FEE = '14056',
    FINANCING_MONTHLY_FEE = '14054',
    FINANCING_MONTHLY_MANAGEMENT_FEE = '14055',
    FINANCING_MONTHLY_PAYMENT_LEASING = '14050',
    FINANCING_MONTHLY_PAYMENT_PART_PAYMENT = '14051',
    FINANCING_MONTHLY_SERVICE_BUDGET = '14053',
    FUEL_CARD_MONTHLY_PAYMENT = '15000',
    IMPORTER_CARE_SUPPORT_MONTHLY_PAYMENT = '14110',
    INSURANCE_MONTHLY_PAYMENT = '13100',
    LATE_PAYMENT_INTEREST = '80000',
    MAINTENANCE_MONTHLY_PAYMENT = '14100',
    MINILEASING = '14061',
    PARKING_BUDGET = '80002',
    PERIODIC_INSPECTION_MONTHLY_PAYMENT = '14120',
    SMARTFLEET_INITIAL_FEE = '33001',
    SMARTFLEET_MONTHLY_FEE = '33000',
    SUBSTITUTE_VEHICLE_MONTHLY_PAYMENT = '14060',
    TIRE_RENEWAL_MONTHLY_PAYMENT = '14211',
    TIRE_STORAGE_MONTHLY_PAYMENT = '14210',
    VEHICLE_TAX_MONTHLY_PAYMENT = '18000',
    VEHICLE_TRACKING_MONTHLY_PAYMENT = '16100',
    FINANCING_MONTHLY_PAYMENT_PART_PAYMENT_INTERST_FEE = '14058',
    SPARE_PARTS = '14106',
}
